PJQ.views.rfq.RFQDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No RFQs have been created yet',
            zeroRecords: "No RFQs matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-rfq')
        },
        toggleRowClass: '.rfq-toggle-row',
        onViewChangeRequest: null
    },
    events: {
        'click .btn-view-rfq': 'viewRFQClicked',
        'click .btn-view-change-request': 'viewChangeRequestClicked'
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter = [];
        return defaultFilter;
    },
    afterSearch: function () {
        if(typeof this.options.afterSearch === 'function'){
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function (){
        new PJQ.inputs.Selectpicker({
            el: this.$('.rfq-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.rfq.filterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.rfq.filterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.rfq.filterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');

        let columns = [],
            includeColumns = ['status', 'changeRequest', 'title', 'number', 'description', 'assignees', 'amount'];

        columns.push({
            "columnData": "childData",
            "data": null,
            "title": "",
            "width": "20px",
            "orderable": false,
            "searchable": false,
            "defaultContent": '',
            "render": function (data, type, row) {
                return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
            }
        });

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.rfq.rfqStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'changeRequest':
                    columns.push({
                        "columnData": "changeRequest",
                        "title": "Change Request",
                        "data": "attributes.changeRequestId",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if(this.options.canViewChangeRequests){
                                return '<a class="btn-view-change-request" href="javascript:void(0)" data-id="' + row.get('changeRequestId') + '">' + row.get('changeRequestNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            return '<a class="btn-view-rfq" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if(_.size(data) === 0){
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'assignees':
                    columns.push({
                        "columnData": "assignees",
                        "title": "Assigned To",
                        "titleSettings": "Assigned To",
                        "render": _.bind(function (data, type, row) {
                            if (_.size(row.assignees.models) === 0) {
                                return 'Nobody';
                            }

                            return _.map(row.assignees.models, function (assignee) {
                                let res = assignee.get('contactName');
                                return _.size(res) > 0 ? res : assignee.get('companyName');
                            }).join(', ');
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-rfq ml-1" title="View RFQ"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewRFQClicked: function (e){
        if(typeof(this.options.onViewRFQ) === 'function'){
            let row = this.getRow((e.currentTarget).closest('tr')),
                rfq = row.data();
            if(rfq != null){
                this.options.onViewRFQ(rfq);
            }
        }
    },
    viewChangeRequestClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewChangeRequest(row.data().get('changeRequestId'));
    },
    viewChangeRequest: function(changeRequestId) {
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: new PJQ.models.changeRequests.ChangeRequest({
                id: changeRequestId
            })
        });
    }
});